export const INSOMNIA_HELP_URL = "https://www.nhs.uk/conditions/insomnia/";
export const ACID_RAID_URL = "https://acidtechnoradio.dance/";
export const ACID_SITE_URL = "https://acidtechnoradio.dance/";
export const ZI_SITE_URL = "https://www.zienzi.dance/";
export const BOARDS_OF_CANADA_URI = "spotify:artist:2VAvhf61GgLYmC6C8anyX1";
